<template>
  <div class="animated fadeIn">
    <SoilNutrients :results="results" />
    <SoilCharacteristics :results="results" />
    <SoilTextureCharacteristics :results="results" />
    <LaboratoryGuidelines :results="results" />
  </div>
</template>
  
<script>
import LaboratoryGuidelines from './soil/LaboratoryGuidelines.vue';
import SoilCharacteristics from './soil/SoilCharacteristics.vue';
import SoilNutrients from './soil/SoilNutrients.vue'
import SoilTextureCharacteristics from './soil/SoilTextureCharacteristics.vue';
import ResultModel from "@/models/modus/ResultModel";

export default {
  name: "SubmissionSoilReport",
  components: { SoilNutrients, SoilCharacteristics, SoilTextureCharacteristics, LaboratoryGuidelines },
  props: {
    results: {
      type: Object,
      default: () => new ResultModel
    },
  },
}
</script>